import { useEffect, useState } from 'react'
import {
    ScoopStepper,
    ScoopButton,
    ScoopText,
    ScoopDialog,
    ScoopTable,
    ScoopTab,
    ScoopTabPanel,
    ScoopDivider,
    ScoopColumn,
} from '../../../../ui'
import Sheetlet from '../../Sheetlet/Sheetlet.jsx'
import { renderToString } from 'react-dom/server'
import googleSheetsIcon from '../../../../../assets/source/GoogleSheets.svg'
import styles from './CalculatedColumnsDialog.module.scss'

const CalculatedColumnsDialog = ({
    onClose,
    goBack,
    activeStep,
    steps,
    goForward,
    inboxID,
    isBlending,
    serverContext,
}) => {
    const [tabValue, setTabValue] = useState('0')
    const [previewData, setPreviewData] = useState(null)

    const sheetRange = {
        sheetType: 'CalculatedSource',
        inboxID: inboxID,
    }

    const [outputDefinition, setOutputDefinition] = useState(null)

    const tabs = [
        { key: '0', label: isBlending ? 'Blend' : 'Create' },
        { key: '1', label: 'Preview Data' },
    ]

    useEffect(() => {
        tabValue === '1' ? updatePreviewData() : getOutputDefinition()
    }, [tabValue])

    const getOutputDefinition = async () => {
        await serverContext.server.sheetPostData(
            {
                action: 'getCSWDefinition',
                inboxID: inboxID,
            },
            processOutputDefinition
        )
    }

    const processOutputDefinition = (results) => {
        if (!results.queries) return
        setOutputDefinition(results)
    }

    const updatePreviewData = async () => {
        await serverContext.server.sheetPostData(
            {
                action: 'getCSWPreviewData',
                inboxID: inboxID,
                singleQuery: !isBlending,
            },
            processPreviewData
        )
    }

    const processPreviewData = (results) => {
        if (results && results.rows && results.columns) setPreviewData(results)
    }

    return (
        <ScoopDialog
            maxWidth={'xl'}
            open
            onClose={onClose}
            title={
                <ScoopStepper activeStep={activeStep} steps={steps} className={styles.stepper} />
            }
            actions={
                <>
                    <ScoopButton variant="grey" size="sm" onClick={goBack}>
                        Back
                    </ScoopButton>
                    <ScoopButton variant="default" size="sm" onClick={goForward}>
                        Continue
                    </ScoopButton>
                </>
            }
        >
            <ScoopDivider />
            <ScoopColumn className={styles.container}>
                <ScoopColumn className={styles.header}>
                    <ScoopText className={styles.title}>Create Calculated Columns</ScoopText>
                    {isBlending ? (
                        <p className={styles.description}>
                            Blend both data queries together by matching fields and creating
                            blending conditions.
                            <a href={'#'} className={styles.link}>
                                {' '}
                                Watch the video{' '}
                            </a>
                            to learn how.
                        </p>
                    ) : (
                        <p className={styles.description}>
                            Lorem ipsum dolor sit amet consectetur. Venenatis at adipiscing sapien
                            fames integer eu scelerisque orci.
                        </p>
                    )}
                </ScoopColumn>
                <ScoopColumn className={styles.tabSection}>
                    <div className={styles.tabContainer}>
                        <ScoopTab
                            variant="underline"
                            tabs={tabs}
                            value={tabValue}
                            onChange={(e, newValue) => setTabValue(newValue)}
                        />
                    </div>
                    <div>
                        <ScoopTabPanel value={'0'} selectedValue={tabValue}>
                            <Sheetlet
                                isBlending={isBlending}
                                serverContext={serverContext}
                                sheetRange={sheetRange}
                                locked={true}
                                height={400}
                                cornerHTML={
                                    '<a href="https://docs.google.com/spreadsheets/d/' +
                                    outputDefinition?.worksheetID +
                                    '" target="_blank">' +
                                    renderToString(
                                        <img alt={'Google sheets'} src={googleSheetsIcon} />
                                    ) +
                                    '</a>'
                                }
                                addNew={getOutputDefinition}
                            />
                        </ScoopTabPanel>
                        <ScoopTabPanel value={'1'} selectedValue={tabValue}>
                            {previewData && (
                                <ScoopTable
                                    columns={previewData.columns}
                                    rows={previewData.rows}
                                    rowHeight={20}
                                    domLayout="autoHeight"
                                />
                            )}
                        </ScoopTabPanel>
                    </div>
                </ScoopColumn>
            </ScoopColumn>
        </ScoopDialog>
    )
}

export default CalculatedColumnsDialog
